const NAMESPACE = "projectTableProgressMessage";

const KEYS = {
    processingMessage: "processingMessage",
    processedCountMessage: "processedCountMessage",
    cancelImportHeader: "cancelImportHeader",
    cancelImportMessage: "cancelImportMessage",
    cancellingImportMessage: "cancellingImportMessage"
};

const MESSAGES = {
    [KEYS.processingMessage]: {
        value: "Processing...",
        comment: "Text to display when processing items for a project table"
    },
    [KEYS.processedCountMessage]: {
        value: "Processed {processedCount} of {totalCount}",
        comment: "Text to display when processing items for a project table"
    },
    [KEYS.cancelImportHeader]: {
        value: "Cancel Import",
        comment: "Text to display when trying to cancel an import"
    },
    [KEYS.cancelImportMessage]: {
        value: "Are you sure you want to cancel? This could lead to partially imported data in the project table.",
        comment: "Text to display to confirm cancelling a project table import"
    },
    [KEYS.cancellingImportMessage]: {
        value: "Cancelling import...",
        comment: "Text to display when trying to cancel an import"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
